import { render, staticRenderFns } from "./CommercialIDialCampaign.vue?vue&type=template&id=07a4d600&scoped=true"
import script from "./CommercialIDialCampaign.vue?vue&type=script&lang=js"
export * from "./CommercialIDialCampaign.vue?vue&type=script&lang=js"
import style0 from "./CommercialIDialCampaign.vue?vue&type=style&index=0&id=07a4d600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a4d600",
  null
  
)

export default component.exports